import type { UserDataWithOnboardingStatus } from '@safc/api-client';
import { useNavigate } from 'react-router';

import { RoutePaths } from '../routes.js';

export const useNavigateToDefaultPage = ({
  user,
}: {
  user?: UserDataWithOnboardingStatus;
}) => {
  const navigate = useNavigate();

  const navigateToDefaultPage = () => {
    if (!user) {
      return;
    }

    const isCROfSomeCompany = user.companies.some(
      company => company.role === 'companyRepresentative',
    );
    const hasSomeAccountMemberships = user.accountMemberships.length > 0;

    if (user.isPendingOnboardingApproval) {
      return navigate(RoutePaths.COMPANY);
    }

    if (
      user.isRegistryAdmin
      || (isCROfSomeCompany && !hasSomeAccountMemberships)
    ) {
      void navigate(RoutePaths.ACCOUNTS);
    } else if (user.accountMemberships.length > 0) {
      void navigate(RoutePaths.HOLDINGS);
    } else {
      void navigate(RoutePaths.COMPANY);
    }
  };

  return { navigateToDefaultPage };
};
